import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { FeederMenuType } from '../../types/menu';


/* global console, require, window, localStorage, setTimeout */
@Component({
  selector: 'feeder-search',
  template: require('./feeder-search.component.html'),
})
export class FeederSearchComponent implements OnChanges {
  flat_menu_list: any = {};
  filtered_products: any = {};
  type: FeederMenuType;
  selected_products: any[] = [];

  formControlSearch = new FormControl('');

  @Input() searchOptions!: any;
  @Input() search!: boolean;
  @Output() searchChange = new EventEmitter<boolean>();
  @Output() typeChanged = new EventEmitter<FeederMenuType>();
  @Output() selectedProductsChanged = new EventEmitter<any[]>();

  ngOnChanges() {
    this.flattenSearchList();
    this.formControlSearch.valueChanges
      .pipe(debounceTime(250))
      .subscribe((val) => {
        this.printFilteredProducts(val || '');
      });
  }

  inSelectedProducts(product) {
    return this.selected_products.includes(product);
  }

  printFilteredProducts(searchInput: string) {
    if (searchInput.length > 0) {
      this.searchChange.emit(true);
      if (this.flat_menu_list !== undefined && this.flat_menu_list !== null) {
        const keys = Object.keys(this.flat_menu_list);
        const searchKeys = searchInput.toUpperCase().split(' ');
        keys.forEach((key) => {
          this.filtered_products[key] = this.flat_menu_list[key].filter(
            (item: any) => searchKeys.every((searchKey) => item.product_code.toUpperCase().includes(searchKey))
          );
          this.filtered_products[key].sort((a, b) =>
            a.product_code < b.product_code ? -1 : 1
          );
        });
      }
    } else {
      this.selected_products.length = 0;
      this.type = undefined;
      this.searchChange.emit(false);
      this.typeChanged.emit(this.type);
      this.selectedProductsChanged.emit(this.selected_products);
    }
  }

  filteredKeys() {
    let keys: any[] = [];
    if (
      this.filtered_products !== undefined &&
      this.filtered_products !== null
    ) {
      keys = Object.keys(this.filtered_products);
    }
    if (this.type) {
      keys = keys.filter((item) =>
        item.toUpperCase().includes(this.type.replace('_', ' ').toUpperCase())
      );
    }
    return keys;
  }

  setType(item: FeederMenuType) {
    this.type = item;
    this.typeChanged.emit(this.type);
  }

  changeSelection(price: any) {
    let idx = -1;
    this.selected_products.every((item, index) => {
      if (item.id === price.id) {
        idx = index;
        return false;
      }
      return true;
    });
    if (idx !== -1) {
      this.selected_products.splice(idx, 1);
    } else {
      this.selected_products.push(price);
    }
    this.selectedProductsChanged.emit(this.selected_products);
  }

  flattenSearchList() {
    if (this.searchOptions !== null) {
      const keys = Object.keys(this.searchOptions);
      keys.forEach((key) => {
        this.flat_menu_list[key] = this.flattenSearchObjects(
          this.searchOptions[key]
        );
      });
    }
  }

  flattenSearchObjects(menu: any) {
    let retArr: any[] = [];
    if (menu !== undefined && menu !== null) {
      if (!Array.isArray(menu)) {
        const keys = Object.keys(menu);
        keys.forEach((key) => {
          retArr = retArr.concat(this.flattenSearchObjects(menu[key]));
        });
      } else {
        retArr = retArr.concat(menu);
      }
    }
    return retArr;
  }
}
